import {EventEmitter, Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {Config} from "../services/env.config";
// import { do } from "rxjs/operators";
import {tap, filter} from 'rxjs/internal/operators';
import {BehaviorSubject, Subscription} from 'rxjs';
import {NavbarFiltersAttributes, FiltersAttributes} from './product';
import {Router} from '@angular/router';
import { data } from 'jquery';
// import { catch } from 'rxjs/add/operator';
@Injectable({
  providedIn: 'root'
})
export class ProductService {
  onClickNavbar = new EventEmitter();
  subsVar: Subscription;
  filtersFromNavbar: NavbarFiltersAttributes = new NavbarFiltersAttributes();
  private selectedBrands = new BehaviorSubject<string>('');

  allCheckedCheckboxData: FiltersAttributes = new FiltersAttributes();
  private name = new BehaviorSubject<string>('false');
  nameKeeper = this.name.asObservable();
  selectedBrandsArr = this.selectedBrands.asObservable();


  onFirstComponentButtonClick() {
    this.onClickNavbar.emit();
    //console.log(this.onClickNavbar.emit())
  }
  SetBrandNames(brandNames: any) {
    console.log(brandNames);
    this.selectedBrands.next(brandNames);
  }
  SetName(name: string) {
    console.log(this.name);
    this.name.next(name);
  }
  productDetail: any;
  cpHeaders = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Content-Security-Policy': 'default-src \'self\'; script-src \'self\'; style-src \'self\' \'unsafe-inline\'',
      'Strict-Transport-Security': 'max-age=31536000; includeSubDomains; preload',
      'X-Frame-Options': 'DENY',
      'X-Content-Type-Options': 'nosniff',
      'Referrer-Policy': 'strict-origin-when-cross-origin',
      'Permissions-Policy': 'geolocation=(self), camera=(self),microphone=(self),payment=(self),usb=(self),accelerometer=(self)'
    })
  };

  login(loginData): any {
    return this.http
      .post(Config.LoginEndpoint, JSON.stringify(loginData), this.cpHeaders)
      .toPromise()
      .then((response: any) => {
        return response;
      })
      .catch((error) => {
        return Promise.reject(error);
      });

  }

  getAllFiltersType(filter): any {
    let data = JSON.parse(sessionStorage.getItem('user')) ;
     let user = { UserName : data.UserName , ProductType : filter}; 
    return this.http.post(Config.BaseEndpoint + '/GetFilterMaster' , JSON.stringify(user), this.cpHeaders)
      .toPromise()
      .then((response: any) => {
        return response;
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }

  getProductTypeList() {
    let data = JSON.parse(sessionStorage.getItem('user')) ;
    let DealUserName	= JSON.parse(sessionStorage.getItem('DealUserName'));
     let user = { UserName : data.UserName , DealUserName: DealUserName}; 
    return this.http.post(Config.BaseEndpoint + '/GetProductTypeList' , JSON.stringify(user), this.cpHeaders)
      .toPromise()
      .then((response: any) => {
        return response;
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }

  // downloadStock(pageName, reptype) {
  //   let data = JSON.parse(sessionStorage.getItem('user'));
  //   let DealUserName	= JSON.parse(sessionStorage.getItem('DealUserName'));
  //   let user = { UserName : data.UserName , DealUserName : DealUserName , ProductType: pageName, Reptype: reptype}; 
  //   return this.http.post(Config.BaseEndpoint + '/DownloadStock', JSON.stringify(user), this.cpHeaders)
  //     .toPromise()
  //     .then((response: any) => {
  //       return response;
  //     })
  //     .catch((error) => {
  //       return Promise.reject(error);
  //     });
  // }


  // downloadStock(pageName, withImage,selectedBrands) {
  //   let data = JSON.parse(sessionStorage.getItem('user'));
  //   let user = { UserName : data.UserName , DealUserName : data.DealUserName , WithImage: withImage,BrandList:selectedBrands}; 
  //    console.log("checkmate",user);
     
  //   return this.http.post(Config.BaseEndpoint + '/DownloadStock', JSON.stringify(user), this.cpHeaders)
  //     .toPromise()
  //     .then((response: any) => {
  //       return response;
  //     })
  //     .catch((error) => {
  //       return Promise.reject(error);
  //     });
  // }

  // downloadStock(pageName, withImage,selectedBrands) {
  //   let data = JSON.parse(sessionStorage.getItem('user'));
  //   let user = { UserName : data.UserName , DealUserName : data.UserName ,WithImage: withImage,BrandList:selectedBrands}; 
  //    console.log("checkmate",user);
     
  //   return this.http.post(Config.BaseEndpoint + '/DownloadStock', JSON.stringify(user), this.cpHeaders)
  //     .toPromise()
  //     .then((response: any) => {
  //       return response;
  //     })
  //     .catch((error) => {
  //       return Promise.reject(error);
  //     });
  // }

downloadStock(pageName: string, withImage: boolean, selectedBrands: string[]) {
  const data = JSON.parse(sessionStorage.getItem('user'));
  
  const user = {
    UserName: data.UserName,
    DealUserName: data.UserName,
    WithImage: withImage,
    BrandList: selectedBrands
  };

  console.log("checkmate", user); // should show BrandList as array

  return this.http
    .post(Config.BaseEndpoint + '/DownloadStock', user, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    })
    .toPromise()
    .then((response: any) => {
      console.log('API Success:', response);
      return response;
    })
    .catch((error) => {
      console.error('API Error:', error);
      return Promise.reject(error);
    });
}



  getBrandBasedOnProductType(filter){
    let user = { ProductType : filter}; 
    return this.http.post(Config.BaseEndpoint + '/GetBrand' , JSON.stringify(user), this.cpHeaders)
        .toPromise()
        .then((response: any) => {
          return response;
        })
        .catch((error) => {
          return Promise.reject(error);
        });
   }








  getAllCategory() {

    return this.http.get(Config.BaseEndpoint + 'category/getAllCategorys')
      .toPromise()
      .then((response: any) => {
        return response;
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }

  // Live

  getFiltersByCategory(categoryId): any {
   // debugger;
    return this.http.get(Config.BaseEndpoint + 'productCatalogue/getAllDetailsForProductCatalogueUsingCategoryId/' + categoryId)
      .toPromise()
      .then((response: any) => {
        return response;
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }


  
  getItemDetailByItemCode(itemCode): any {
    //debugger
    return this.http.get(Config.BaseEndpoint + 'productCatalogue/getProductCatalogueUsingItemCode/' + itemCode)
      .toPromise()
      .then((response: any) => {
        return response;
      })
      .catch((error) => {
        return Promise.reject(error);
      });
    //   this.pager.currentPage = pageNo;
    //   let data = JSON.parse(sessionStorage.getItem('user'));
    //   let user = { UserName : data.UserName , PageNo: this.pageNo , ProductCode: this.searchText.toUpperCase()}; 
    //   this.tempData = this.table_value;
    //  this.http.post(Config.BaseEndpoint + '/GetProductListMaster' , JSON.stringify(user), this.cpHeaders)
    //    .toPromise()
    //    .then((response: any) => {
  }

  getProductDetailByItemCode(itemCode): any {
    //debugger;
        let data = JSON.parse(sessionStorage.getItem('user'));
        let userDetails = JSON.parse(sessionStorage.getItem('userDetails'));
      let user = { UserName : data.UserName , ProductCode: itemCode.toUpperCase() , DealUserName : userDetails.DealUserName,TokenId:data.TokenId}; 
      // this.http.post(Config.BaseEndpoint + '/GetProductListMaster' , JSON.stringify(user), this.cpHeaders)
      return this.http.post(Config.BaseEndpoint + '/GetProductDetail' , JSON.stringify(user), this.cpHeaders)
     .toPromise()
     .then((response: any) => {
      return response;
     })
   .catch((error) => {
    return;
     console.log(Promise.reject(error));
   });
  }



   async searchFilters(filterJson, page, size, pagename): Promise<any> {
    
    let data = JSON.parse(sessionStorage.getItem('user')) ;
    let DealUserName	= JSON.parse(sessionStorage.getItem('DealUserName'));
    let order;
    if(filterJson.desc) {
      order = "HIGH TO LOW";
    }
    if(filterJson.asc) {
      order = "LOW TO HIGH";
    }
    if(filterJson.stock) {
      order = "STOCK AVAILABLE";
    }
    if(filterJson.new) {
      order = "NEW";
    }
    let user = { UserName : data.UserName , DealUserName : DealUserName , Password: data.TokenId , PageNo: page , ProductType: pagename ,ProductFilterData:filterJson.ProductFilterData , ProductCode : filterJson.itemCode ,FilterType : order, 
      FromRange : filterJson.startPrice , ToRange : filterJson.endPrice , FromRangeDis: filterJson.FromRangeDis , ToRangeDis: filterJson.ToRangeDis
    }; 
    return await  this.http.post(Config.BaseEndpoint + '/GetProductCatalog' , JSON.stringify(user), this.cpHeaders)
     .toPromise()
     .then((response: any) => {
      return response;
     })
   .catch((error) => {
    return;
     console.log(Promise.reject(error));
   });
    // return this.http
    //   .post(Config.BaseEndpoint + 'productCatalogue/getAllProductCatalogueUsingFilterWithPgination?' + 'page=' + page + '&' + 'size=' + size , JSON.stringify(filterJson), this.cpHeaders)
    //   .pipe(tap((response: any) => {
    //     return response;
    //   })
    //   );
  }

  constructor(private http: HttpClient, private router: Router) { }
}
